// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { displayPercent } from 'common/components/Number';
import Campaign from 'common/modules/campaign/domain/Campaign';
import CampaignMetrics from 'common/modules/campaign/domain/CampaignMetrics';
import DemographyCard from 'common/modules/printing/components/DemographyCard';
import PrintingHeader from 'common/modules/printing/components/PrintingHeader';

import ImpressionsDailyProgressionCard from './ImpressionsDailyProgressionCard';
import MetricsListingCard from './MetricsListingCard';

const Wrapper = styled.div`
  padding: 3px;
  background-color: white;
  box-sizing: border-box;

  width: 8.5in;
  height: 11in;
  font-size: 12px;

  @page {
    margin: 2.00cm 0 2.00cm 0;
  }
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${({ theme }) => theme.metrics.margin}px 0;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  margin-bottom: ${({ theme }) => theme.metrics.margin}px;
`;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 16px;
  margin-top: ${({ theme }) => theme.metrics.tinyMargin}px;
  text-align: center;
`;

const Content = styled.div`
  margin-top: 0px;
`;

const ImpressionsDailyWrapper = styled.div`
  display: flex;
  height: 320px;
`;

type Props = {
  campaign: Campaign,
  metrics: CampaignMetrics,
  follo: boolean,

  theme: any,
  t: any,
}

function CampaignPrinting(props: Props) {
  const { campaign, metrics, follo, theme, t } = props;

  return (
    <Wrapper>
      <PrintingHeader radio={campaign.radio} />
      <Header>
        <Title style={{ ...theme.fonts.style.secondary, fontWeight: 'bold' }}>{campaign.name.toUpperCase()}</Title>
        <Text>{t('campaignDateDisplay', campaign.dateRange)}</Text>
        <Text>{t('commonCampaign:campaignProgressionWithValue', { value: displayPercent(metrics.progress) })}</Text>
      </Header>
      <Content>
        <MetricsListingCard metrics={metrics} campaign={campaign} follo={follo} />
        <ImpressionsDailyWrapper>
          <ImpressionsDailyProgressionCard campaign={campaign} metrics={metrics} />
        </ImpressionsDailyWrapper>
        <DemographyCard ageGroup={metrics.ageGroup} genderDemography={metrics.genderDimension} />
      </Content>
    </Wrapper>
  );
}

export default withTheme(translate(['commonSales', 'commonCampaign'])(CampaignPrinting));



// WEBPACK FOOTER //
// ./src/common/modules/campaign/components/printing/CampaignPrinting.js